(function () {
  var overlay = document.getElementById('email-popup-overlay');
  var popup = document.getElementById('email-popup');
  if (!overlay || !popup) return;

  var DISMISS_KEY = 'moodEmailPopupDismissed';
  var closeBtn = document.getElementById('email-popup-close');
  var form = document.getElementById('email-popup-form');
  var emailInput = document.getElementById('email-popup-email');
  var submitLabel = document.getElementById('email-popup-submit-label');
  var copyBtn = document.getElementById('email-popup-copy-btn');
  var copyLabel = document.getElementById('email-popup-copy-label');

  var dismissed = false;
  try { dismissed = localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) {}

  function openPopup() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }

  if (!dismissed) {
    setTimeout(openPopup, 6000);
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      if (submitLabel) submitLabel.textContent = 'Unlocking…';

      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[email]', email);
      body.set('contact[tags]', 'newsletter,popup-mood10');
      body.set('contact[accepts_marketing]', '1');

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      }).catch(function (err) {
        console.error('Newsletter capture error:', err);
      });

      popup.dataset.state = 'success';
      try { localStorage.setItem(DISMISS_KEY, '1'); } catch (err) {}
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = 'MOOD10';
      var showCopied = function () {
        if (copyLabel) copyLabel.textContent = 'Copied ✓';
        setTimeout(function () {
          if (copyLabel) copyLabel.textContent = 'Copy code';
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(showCopied);
      } else {
        showCopied();
      }
    });
  }
})();
